var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeriwinkle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 80,
    viewBox: "0 0 89 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89,
    height: 80,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_2894)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1113,
    y: -902,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "url(#paint0_linear_1153_2894)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.605248,
    d: "M32.4521 12.5801C33.6933 -1.0271 53.3094 -1.73795 55.5323 11.7437C56.9038 20.0618 64.9985 25.5063 73.2198 23.6403C86.5445 20.6159 93.2823 39.0522 81.1474 45.3324C73.6603 49.2072 70.9836 58.5882 75.2988 65.8304C82.2928 77.5685 66.8408 89.6736 57.1182 80.0733C51.1194 74.15 41.3704 74.5032 35.8161 80.8452C26.8138 91.1241 10.5262 80.1691 16.6522 67.9557C20.4319 60.4201 17.0833 51.2574 9.33532 47.9347C-3.22234 42.5494 2.16331 23.6737 15.672 25.7257C24.0068 26.9917 31.6862 20.9756 32.4521 12.5801ZM45.6728 58.5504C52.5123 58.3026 57.8559 52.5571 57.6081 45.7175C57.3602 38.878 51.6148 33.5344 44.7752 33.7822C37.9357 34.0301 32.592 39.7755 32.8399 46.6151C33.0877 53.4546 38.8332 58.7983 45.6728 58.5504Z",
    fill: "#F2DA05",
    stroke: "#111111",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_2894",
    x1: -357,
    y1: -902,
    x2: -357,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474002,
    stopColor: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D4E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1113,
    y: -902,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeriwinkle3);
export default __webpack_public_path__ + "static/media/Periwinkle-3.fbd5806a27a638d693a9b325912e7b81.svg";
export { ForwardRef as ReactComponent };